<template>
  <q-badge
    v-bind="$attrs"
    class="text-center ellipsis"
    :color="color"
    :style="{ background: color }"
    :label="$attrs.label ||$attrs.name"
  />
</template>

<script>
export default {
  name: 'LwfBadge',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style scoped>

</style>
